import { useState } from "react"
import { SITE } from "@/data/site"

const ITEMS = [
  {
    q: "如何訂購這款限定珍藏香氛？",
    a: "請先完成銀行轉帳，再填寫訂購人資料、匯款確認與 7-ELEVEN 店到店資訊。我們核對款項無誤後，會依訂單順序安排出貨。",
  },
  {
    q: "付款方式與金額怎麼計算？",
    a: "目前只提供銀行轉帳。售價 NT$1,580 已含 7-ELEVEN 店到店運費，匯款金額請依訂購組數計算，無須另加運費。",
  },
  {
    q: "收件方式是什麼？",
    a: "全館採 7-ELEVEN 店到店寄送。請填寫正確的門市名稱與地址，以利順利寄達。",
  },
  {
    q: "訂單成立後，多久會出貨？",
    a: "訂單送出後會寄送 Email，確認我們已收到您的訂單資訊。待核對匯款無誤，將依付款順序安排出貨。",
  },
  {
    q: "全球限量珍藏香氛售完後會補貨嗎？",
    a: `${SITE.edition} 為野東西限定珍藏香氛，售完即不再製作，敬請把握珍藏機會。`,
  },
  {
    q: "還有其他問題可以怎麼聯絡？",
    a: `歡迎來信 ${SITE.email}，或致電 ${SITE.phone}。`,
  },
]

function Faq() {
  const [open, setOpen] = useState(0)

  return (
    <section id="faq" className="relative w-full bg-[#080808] px-8 py-28 md:px-16 md:py-40 lg:px-24">
      <p className="font-sans-ui text-center text-[11px] tracking-[0.48em] text-[#c4a574]">08</p>
      <h2 className="font-display mt-6 text-center text-4xl text-[#f7f1e6] md:text-6xl">常見問題</h2>
      <div className="mx-auto mt-16 max-w-3xl border-t border-white/10">
        {ITEMS.map((item, index) => {
          const isOpen = open === index
          return (
            <div key={item.q} className="border-b border-white/10">
              <button
                type="button"
                className="flex w-full items-center justify-between gap-6 py-6 text-left"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? -1 : index)}
              >
                <span className="font-serif-tc text-lg text-stone-100">{item.q}</span>
                <span
                  className={`font-sans-ui shrink-0 text-lg text-[#c4a574] transition-transform duration-500 ${
                    isOpen ? "rotate-45" : "rotate-0"
                  }`}
                >
                  +
                </span>
              </button>
              <div
                className={`grid transition-all duration-500 ease-out ${
                  isOpen ? "grid-rows-[1fr] pb-8 opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="font-sans-ui max-w-lg text-left text-[13px] leading-7 text-stone-400">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default Faq
